import { updateFormDescriptionFields, updateFormTitleFields } from './common';
export const generateUpdateTaskPayload = ({ formState, updatedFormFields, }) => ({
    ...updateFormTitleFields({ formState, updatedFormFields }),
    ...(updatedFormFields.has('internalTitle') ? { internalTitle: formState.internalTitle } : {}),
    ...(updatedFormFields.has('selectedTaskType')
        ? {
            taskType: formState.selectedTaskType === 'location'
                ? 'check-in'
                : formState.selectedTaskType === 'info'
                    ? 'information'
                    : 'action',
            ...(formState.selectedTaskType === 'info'
                ? {}
                : { answerType: formState.selectedTaskType }),
        }
        : {}),
    ...updateFormDescriptionFields({ formState, updatedFormFields }),
    ...(updatedFormFields.has('fileReference')
        ? { fileReference: formState.fileReference ? formState.fileReference : '' }
        : {}),
    ...(updatedFormFields.has('coordinatesLat')
        ? { coordinatesLat: formState.coordinatesLat ? +formState.coordinatesLat : 0 }
        : {}),
    ...(updatedFormFields.has('coordinatesLon')
        ? { coordinatesLon: formState.coordinatesLon ? +formState.coordinatesLon : 0 }
        : {}),
    ...(updatedFormFields.has('radius') ? { radius: formState.radius ? +formState.radius : 0 } : {}),
    ...(updatedFormFields.has('successPoints')
        ? { successPoints: formState.successPoints ? formState.successPoints : 0 }
        : {}),
    ...(updatedFormFields.has('failurePoints')
        ? { failurePoints: formState.failurePoints ? formState.failurePoints : 0 }
        : {}),
    ...(updatedFormFields.has('taskAnswers') &&
        (formState.selectedTaskType === 'single-selection' ||
            formState.selectedTaskType === 'multiple-selection')
        ? {
            answers: formState.taskAnswers.map((answer) => ({
                ...(answer.uid ? { uid: answer.uid } : {}),
                content: answer.translations,
                isCorrect: answer.isCorrect,
                sort: answer.sort,
            })),
        }
        : {}),
});
